<template>
    <div class="field">
        <div class="control has-icons-left">
            <input v-model="auction"
                   v-bind:class="{ 'is-danger': error && error.length > 0 }"
                   class="input"
                   type="text"
                   placeholder="Type Auction or Shop">
            <span class="icon is-small is-left">
                <i class="fas fa-gavel"></i>
            </span>
            <p v-if="error && error.length > 0" class="help is-danger">{{ error[0] }}</p>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            auction: {
                get: function () {
                    return this.$store.getters.getNewCarAuction
                },
                set: function (value) {
                    this.$store.dispatch('setNewCarAuction', value)
                }
            },
            error: {
                get: function () {
                    return this.$store.getters.getNewCarErrorAuction
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Cars/Create/Inputs/AuctionInput.vue